import { useParams } from 'react-router-dom';
import DashboardLayout from '../../../../../commons/DashboardLayout/DashboardLayout';
import { Helmet } from 'react-helmet';
import moment from 'moment';
import { useCommissionsByMonth } from '../../../../../../hooks/fetchers/useCommissionsByMonth/useCommissionsByMonth';
import { useEffect } from 'react';
import { formatPrice } from '../../../../../../utils/helpers/price/formatPrice';
import { useBoostsByMonth } from '../../../../../../hooks/fetchers/useBoostsByMonth/useBoostsByMonth';
import { getPeriodLabel } from '../../../../../../utils/helpers/stats/getPeriodLabel';
import { getStatKeyLabel } from '../../../../../../utils/helpers/stats/getStatKeyLabel';
import { getStatPeriodDate } from '../../../../../../utils/helpers/stats/getStatPeriodDate';

export default () => {
  const { month, year } = useParams();

  const { data: commissions } = useCommissionsByMonth({
    month: parseInt(month as string),
    year: parseInt(year as string),
  });

  const { data: boosts } = useBoostsByMonth({
    month: parseInt(month as string),
    year: parseInt(year as string),
  });

  useEffect(() => console.log('boosts', boosts), [boosts]);

  return (
    <>
      <Helmet>
        <title>
          Facture de {moment(`${month}-${year}`, 'M-Y').locale('fr').format('MMMM YYYY')}
        </title>
      </Helmet>
      <DashboardLayout>
        {(commissions && commissions.length > 0) &&
          <div className='flex-column'>
            <h3>Commissions</h3>
            <table className="dashboard__table" style={{ width: '100%', flex: 0 }}>
              <colgroup>
                <col style={{ width: '50%' }} />
                <col />
                <col />
                <col />
              </colgroup>
              <thead>
                <tr>
                  <th>Entreprise</th>
                  <th>Plan</th>
                  <th>Montant</th>
                  <th>Date</th>
                </tr>
              </thead>
              <tbody>
                {commissions?.map(({ company_name, plan_name, amount, created_at }, index) => {
                  return (
                    <tr key={index}>
                      <td>{company_name}</td>
                      <td>{plan_name}</td>
                      <td>{formatPrice(amount)} €</td>
                      <td>{moment(created_at).format('DD/MM/YYYY')}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        }
        {(boosts && boosts.length > 0) &&
          <div className='flex-column'>
            <h3>Boosts</h3>
            <table className="dashboard__table" style={{ width: '100%', flex: 0 }}>
              <colgroup>
                <col style={{ width: '50%' }} />
                <col />
                <col />
                <col />
              </colgroup>
              <thead>
                <tr>
                  <th>Type</th>
                  <th>Période</th>
                  <th>Date</th>
                  <th>Montant</th>
                  <th>Assigné le</th>
                </tr>
              </thead>
              <tbody>
                {boosts?.map(({ stats_key, period, amount, stat_date, created_at }, index) => {
                  const statKeyLabel = getStatKeyLabel(stats_key)
                  const periodLabel = getPeriodLabel(period)
                  const periodDate = getStatPeriodDate({ period, stat_date })

                  return (
                    <tr key={index}>
                      <td>{statKeyLabel}</td>
                      <td>{periodLabel}</td>
                      <td>{periodDate}</td>
                      <td>{formatPrice(amount)} €</td>
                      <td>{moment(created_at).format('DD/MM/YYYY')}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        }
      </DashboardLayout>
    </>
  );
};
